import { getTelemedicineLink } from "../../services";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { CircularProgress } from "@mui/material";

const ModalTelemedicine = ({ cpf, token, onClose }) => {
  const [copiedText, setCopiedText] = useState(null);

  // Função para copiar o link ao clicar no input
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setCopiedText(text); // Armazena o texto copiado
    setTimeout(() => setCopiedText(null), 2000); // Limpa a mensagem após 2 segundos
  };

  // Consulta para pegar o link telemedicina
  const { data, isLoading, isError } = useQuery(
    ["userLinks", { cpf, token }],
    () => getTelemedicineLink({cpf, token})
  );

  return (
    <div
      onClick={onClose}
      className="h-screen w-screen fixed z-50 top-0 left-0 bg-black bg-opacity-30 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="flex flex-col items-center justify-between w-96 h-80 rounded-md p-4 bg-white shadow-lg">
        <h1 className="text-xl font-bold mb-4 w-full">Link para Telemedicina</h1>
        { isLoading ? 
          <div className="h-full w-full flex items-center justify-center">
            <CircularProgress />
          </div>
          :
          isError ? 
          <div className="h-full w-full flex items-center justify-center">
            <div>Erro ao carregar os dados.</div>
          </div>
          :
          data && 
              <>
                <p className="text-sm font-semibold mb-2 w-full">Nome: {data.name}</p>

                <div className="flex flex-col mb-4 w-full">
                  <label className="mb-1 font-medium">Link de Consulta:</label>
                  <input
                    className="px-2 py-1 border rounded-md cursor-pointer bg-gray-100 text-gray-600"
                    value={data.appointment}
                    readOnly
                    onClick={() => handleCopy(data.appointment)}
                  />
                  {copiedText === data.appointment && (
                    <span className="text-green-500 text-sm mt-1">Link copiado!</span>
                  )}
                </div>

                <div className="flex flex-col mb-4 w-full">
                  <label className="mb-1 font-medium">Link de Emergência:</label>
                  <input
                    className="px-2 py-1 border rounded-md cursor-pointer bg-gray-100 text-gray-600"
                    value={data.appointmentEmergency}
                    readOnly
                    onClick={() => handleCopy(data.appointmentEmergency)}
                  />
                  {copiedText === data.appointmentEmergency && (
                    <span className="text-green-500 text-sm mt-1">Link copiado!</span>
                  )}
                </div>

                <button
                  className="px-4 py-2 rounded-md bg-red-500 text-white hover:bg-red-600 duration-300 ease-in-out self-end"
                  onClick={onClose}
                >
                  Fechar
                </button>
              </>
        }
      </div>
    </div>
  );
};

export default ModalTelemedicine;
